import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isEditMode", "variant", "addText", "editText", "addAriaLabel", "editAriaLabel", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
function AddOrEditButton(_ref) {
  var isEditMode = _ref.isEditMode,
    variant = _ref.variant,
    addText = _ref.addText,
    editText = _ref.editText,
    addAriaLabel = _ref.addAriaLabel,
    editAriaLabel = _ref.editAriaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return isEditMode ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    icon: "edit",
    size: size,
    variant: variant,
    "aria-label": editAriaLabel
  }, otherProps), {}, {
    children: editText || t('actions_edit')
  })) : /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    icon: "plus",
    size: size,
    variant: variant,
    "aria-label": addAriaLabel
  }, otherProps), {}, {
    children: addText || t('actions_add')
  }));
}
export default AddOrEditButton;